export const TOPIC_URL = process.env.REACT_APP_SOCKET_TOPIC_URL
  ? process.env.REACT_APP_SOCKET_TOPIC_URL
  : 'https://staging.ebatpro.fr';

export const CART_TOPIC = `${TOPIC_URL}/cart`;
